import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FlowConfigContext } from '../../../providers/FlowConfigContext';

export interface OwnerSignsMessageProps {
  marginBottom: number;
}

export default function OwnerSignsMessage(props: OwnerSignsMessageProps): JSX.Element {
  const { marginBottom } = props;
  const { provider, ownerSignsEnabled } = useContext(FlowConfigContext);
  const { t } = useTranslation();

  return (
    <>
      {ownerSignsEnabled && (
        <div
          data-testid="CLIENT_BROADCASTS"
          className={`mb-${marginBottom} flex-grow-1 flex-shrink-0 declarations italic text-textParagraph`}
        >
          {t('common.ownerSigns', { context: provider || '' })}
        </div>
      )}
    </>
  );
}
